/**
 * @Author: v_jppjpeng
 * @Date: 2023-6-28 17:21:47
 * @Explain: 联系人管理 - 字段设置
 */
import type { ConnectState } from '@/models/connect';
import { FixedFieldEnum } from '@/pages/contactManage/fieldSettings/data.d';
import { getDvaApp } from 'umi';
import http from '../http';

const MODEL = '/extra';
const NEW_MODEL = '/business_user';

export default {
  /**
   * 列表
   * @isUse: //是否查询使用情况 1-查询  0-不查询
   **/
  // getList(data: { isUse: number }) {
  //   return http.post(`${MODEL}/list`, data);
  // },
  // 自定义字段配置列表
  // getFieldConfigList(data: Record<any, any>) {
  //   return http.post(`/businessUser/field-new`, data);
  // },
  getFieldConfigList(data: Record<any, any>) {
    const { getState } = getDvaApp()._store;
    const { CommonModel }: ConnectState = getState();
    const { currentBusinessOpenWhatsApp } = CommonModel;
    return http
      .post(`${NEW_MODEL}/attributes`, data, {
        params: { switchReqToUnderline: true, ver: 'v2' },
      })
      .then((res) => {
        const newData = Array.isArray(res?.data)
          ? res.data.filter((item) => {
              // 当前业务未开通WhatsApp则拦截WhatsApp字段
              if (!currentBusinessOpenWhatsApp) {
                return item.id !== FixedFieldEnum.WhatsApp;
              }
              return item;
            })
          : [];
        return { ...res, data: newData };
      });
  },
  // 新增
  onAddEdit(data: Record<any, any>) {
    return http.post(`${MODEL}/save`, data);
  },
  // 删除
  onDel(data: { id: number }) {
    return http.post(`${MODEL}/del`, data);
  },
  // 保存自定义字段
  onSave(data: Record<any, any>) {
    return http.post(`/businessUser/field-config`, data);
  },
};
